import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import "./landing.css";
import { SplashLoader } from "./SplashLoader";
import { LandingNav } from "./LandingNav";
import { MarketingFooter } from "./MarketingFooter";
import { useAuth } from "@/hooks/useAuth";

export default function MarketingLayout() {
  const { isAuthenticated, loading } = useAuth();
  // Skip splash entirely for signed-in users so returning partners land straight on marketing.
  const [splash, setSplash] = useState(() => !sessionStorage.getItem("ff_splash_shown"));
  const { pathname } = useLocation();

  useEffect(() => {
    if (loading) return;
    if (isAuthenticated) {
      sessionStorage.setItem("ff_splash_shown", "1");
      setSplash(false);
      return;
    }
    if (!splash) return;
    const t = setTimeout(() => {
      sessionStorage.setItem("ff_splash_shown", "1");
      setSplash(false);
    }, 2600);
    return () => clearTimeout(t);
  }, [splash, isAuthenticated, loading]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="lp-root min-h-screen" data-testid="marketing-layout">
      <AnimatePresence>{splash && <SplashLoader />}</AnimatePresence>
      <LandingNav />
      <Outlet />
      <MarketingFooter />
    </div>
  );
}
